angular.module('elfium').directive('elfiumOnEnter', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.elfiumOnEnter, { 
                            $event: event 
                        });
                    });
                    event.preventDefault();
                }
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumOnEnter.ts